import { useEffect } from 'react'

import { resolveTokens } from '../styles/themeTokens'

/**
 * Hold the reader's light palette for as long as the page is mounted.
 *
 * The book has one look. Dark mode belongs to the author's workbench, and a
 * reader-facing page that inherits it stops looking like a book and starts looking
 * like an app — so every such page pins the light tokens and restores whatever was
 * there on the way out.
 *
 * `data-theme` is only a marker; the values themselves come from React context
 * (`ThemeVariables` in App.tsx), which is why this writes them onto the element.
 */
export function useReaderLightPalette(): void {
  useEffect(() => {
    const html = document.documentElement
    const lightTokens = resolveTokens('light')
    const previous: Array<[string, string]> = Object.keys(lightTokens).map((key) => [
      key,
      html.style.getPropertyValue(key),
    ])

    for (const [key, value] of Object.entries(lightTokens)) {
      html.style.setProperty(key, value)
    }

    return () => {
      for (const [key, value] of previous) {
        if (value) {
          html.style.setProperty(key, value)
        } else {
          html.style.removeProperty(key)
        }
      }
    }
  }, [])
}
